export const NOT_RENDERED_COMPONENT_APIS = 'You should not access not rendered component apis.';

export function catchRenderException(arg: () => void, defaultValue?: any): any {
  try {
    return arg();
  } catch (e) {
    const { message } = e as Error;
    if (!NOT_RENDERED_COMPONENT_APIS.includes(message)) {
      console.error(e);
    }
    return defaultValue;
  }
}
